import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const staffService = { constants, slice, sagas };

export default staffService;

